import React, {useEffect} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Config from '../../../../src/config/config';
import './style.css';

//material-ui core
import {Button, Divider, Typography} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip_Ui from '@material-ui/core/Tooltip/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import {grey} from '@material-ui/core/colors';
import Alert from '@material-ui/lab/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MobileStepper from '@material-ui/core/MobileStepper';

//material-ui Icons
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import EditIcon from '@material-ui/icons/Edit';
import StreetviewIcon from '@material-ui/icons/Streetview';
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';

//import others
// import Image from 'material-ui-image/lib/components/Image/Image';
import indonesia from '../../../assets/img/indonesia.png';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Numeral from 'numeral';
import PieChart, {Legend, Series, Tooltip, Format, Label, Connector, Export} from 'devextreme-react/pie-chart';
import LeafletEdit from '../../Custom/LeafletEdit';
import DialogInformasiDetails from './DialogInformasiDetails';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

const useStyles = makeStyles((theme) => ({
  //details
  detailsPajak: {
    fontWeight: 'bold',
    borderRadius: 0,
    padding: 30,
    paddingTop: 10,
    paddingBottom: 0,
    height: 250,
  },
  detailsText: {
    color: 'black',
    paddingBottom: 10,
    textAlign: 'center',
  },
  detailsButton: {
    textTransform: 'Capitalize',
    marginTop: 10,
    marginBottom: 10,
  },
  detailsHide: {
    width: 430,
    textAlign: 'center',
    position: 'absolute',
    bottom: 15,
    // left: 100,
  },
  detailsHideButton: {
    borderRadius: 13,
    fontWeight: 'bold',
    // textTransform: 'Lowercase',
  },
  divImg: {
    marginTop: 70,
    // marginBottom: 30,
  },
  img: {
    height: 270,
    maxWidth: 450,
    overflow: 'hidden',
    display: 'block',
    width: '100%',
  },
  grid: {
    height: 280,
  },
  gridItem: {
    textAlign: 'center',
  },
  view: {
    position: 'absolute',
    top: 285,
    width: '100%',
    textAlign: 'center',
  },
  iconButton: {
    color: 'rgba(0,0,0,0.54)',
    backgroundColor: '#fafafa',
    '&:hover': {
      color: 'rgba(0,0,0,0.91)',
      backgroundColor: '#fafafa',
    },
  },
  iconButtonImage: {
    color: 'rgb(255,255,255)',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.62)',
    },
  },
  iconLoadingPiutang: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const stylesImg = {
  img: {
    backgroundColor: (255, 255, 255, 0),
    // width: 109,
    // height: 'auto',
  },
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[50]),
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
  label: {
    // fontSize: 13,
    textTransform: 'none',
  },
}))(Button);

const DialogTitle = withStyles(styles)((props) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const SearchBrowserDetails = (props) => {
  const classes = useStyles();
  const {
    checked,
    handleDetails,
    searchNop,
    searchSppt,
    piutangLoading,
    tahunSPPT,
    handleTahunSPPT,
    itemTahunSPPT,
    detailNop,
    detailSppt,
    images,
    streetView,
  } = props;

  function customizeLabel(arg) {
    return `${arg.point.data.tahun}<br>${arg.point.data.status}`;
  }

  function customizeTooltip(arg) {
    return {
      text: Numeral(arg.value).format('$ 0,0'),
    };
  }

  //dialog informasi details--------------------------------------------------------------------------------------------
  const [openDetails, setOpenDetails] = React.useState(false);

  const handleOpenDetails = () => {
    setOpenDetails(true);
  };
  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length > 0 ? images.length : 1;
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    if (images.length === 0) setActiveStep(0);
  }, [images.length]);

  return (
    <div>
      {/*    Search Details   */}
      <div align={'center'} className={classes.divImg}>
        <img className={classes.img} src={images.length > 0 ? images[activeStep] : indonesia} />
        <MobileStepper
          steps={maxSteps}
          position="static"
          variant="text"
          activeStep={activeStep}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
              Next
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
              <KeyboardArrowLeft />
              Back
            </Button>
          }
        />
        {/*<Image*/}
        {/*  src={images ? images : indonesia}*/}
        {/*  // imageStyle={styles.img}*/}
        {/*  style={stylesImg.img}*/}
        {/*  aspectRatio={16 / 9}*/}
        {/*  disableSpinner*/}
        {/*/>*/}
      </div>

      <div className={classes.view}>
        <Tooltip_Ui title="Informasi Details" arrow>
          <IconButton
            className={images.length > 0 ? classes.iconButtonImage : classes.iconButton}
            aria-label="infromasidetails"
            onClick={handleOpenDetails}>
            <InfoOutlinedIcon />
          </IconButton>
        </Tooltip_Ui>
        <Dialog aria-labelledby="customized-dialog-title" open={openDetails} fullWidth={true} maxWidth="lg">
          <DialogTitle id="customized-dialog-title" onClose={handleCloseDetails}>
            Informasi Details
          </DialogTitle>
          <DialogContent dividers>
            <DialogInformasiDetails
              detailNop={detailNop}
              detailSppt={detailSppt}
              tahunSPPT={tahunSPPT}
              handleTahunSPPT={handleTahunSPPT}
              itemTahunSPPT={itemTahunSPPT}
            />
          </DialogContent>
        </Dialog>

        {/*<Tooltip_Ui title="Edit Layer" arrow>*/}
        {/*  <IconButton*/}
        {/*    className={images ? classes.iconButtonImage : classes.iconButton}*/}
        {/*    aria-label="editlayer"*/}
        {/*    target="_blank"*/}
        {/*    href={'/' + Config.homepage + '/custom/'}>*/}
        {/*    <EditIcon />*/}
        {/*  </IconButton>*/}
        {/*</Tooltip_Ui>*/}

        <Tooltip_Ui title="Street View" arrow>
          <IconButton
            className={images.length > 0 ? classes.iconButtonImage : classes.iconButton}
            aria-label="streetview"
            target="_blank"
            href={streetView}>
            <StreetviewIcon />
          </IconButton>
        </Tooltip_Ui>

        <Tooltip_Ui title="360°" arrow>
          <IconButton
            className={images.length > 0 ? classes.iconButtonImage : classes.iconButton}
            aria-label="360view"
            target="_blank"
            href={'/' + Config.homepage + '/view360/' + (searchNop ? searchNop.nop : '')}>
            <ThreeDRotationIcon />
          </IconButton>
        </Tooltip_Ui>
      </div>

      <Fade in={checked} timeout={{enter: 1700}}>
        <div className={classes.detailsPajak}>
          <Typography variant="h6" className={classes.detailsText}>
            {searchNop.nop}
          </Typography>
          <Divider style={{marginBottom: 20}} />
          <PerfectScrollbar options={{suppressScrollX: true}}>
            <Grid container className={classes.grid}>
              {/* Pemilik */}
              <Grid item xs={4}>
                <p>Wajib Pajak</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>{searchNop.nm_wp}</p>
              </Grid>

              {/* Alamat */}
              <Grid item xs={4}>
                <p>Alamat</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>{searchNop.jalan_wp}</p>
              </Grid>

              {/* Kecamatan */}
              <Grid item xs={4}>
                <p>RT/RW</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>
                  {searchNop.rt_wp} / {searchNop.rw_wp}
                </p>
              </Grid>

              {/* Kecamatan */}
              <Grid item xs={4}>
                <p>Kecamatan</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>{searchNop.nm_kecamatan}</p>
              </Grid>

              {/* Kelurahan */}
              <Grid item xs={4}>
                <p>Kelurahan</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>{searchNop.nm_kelurahan}</p>
              </Grid>

              {/* Luas Tanah */}
              <Grid item xs={4}>
                <p>Luas Bumi</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>
                  {Numeral(searchNop.total_luas_bumi).format('0,0')} M<sup>2</sup>
                </p>
              </Grid>

              {/* Luas bangunan	 */}
              <Grid item xs={4}>
                <p>Luas bangunan</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>
                  {Numeral(searchNop.total_luas_bng).format('0,0')} M<sup>2</sup>
                </p>
              </Grid>

              {/* NJOP Tanah */}
              <Grid item xs={4}>
                <p>NJOP Tanah</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>Rp.{Numeral(searchNop.njop_bumi).format('0,0')}</p>
              </Grid>

              {/* NJOP Bangunan */}
              <Grid item xs={4}>
                <p>NJOP Bangunan</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>Rp.{Numeral(searchNop.njop_bng).format('0,0')}</p>
              </Grid>

              {/* Kode ZNT */}
              <Grid item xs={4}>
                <p>Kode ZNT</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>
                  {searchNop.kd_znt} / {searchNop.nir}
                </p>
              </Grid>

              {/* Kode ZNT */}
              <Grid item xs={4}>
                <p>Jenis Bumi</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>{searchNop.jenis_bumi}</p>
              </Grid>

              {/* Latitude */}
              <Grid item xs={4}>
                <p>Koordinat</p>
              </Grid>
              <Grid item xs={1} className={classes.gridItem}>
                :
              </Grid>
              <Grid item xs={7}>
                <p>{searchNop.latitude + ', ' +searchNop.longitude}</p>
              </Grid>

              {/* penyampaian SPPT */}
              {searchNop.length != 0 ? (
                <Grid item xs={12} style={{textAlign: 'center'}}>
                  <Divider
                    style={{
                      marginTop: 10,
                      marginBottom: 20,
                      marginLeft: 70,
                      marginRight: 70,
                    }}
                  />
                  <p>Pembayaran SPPT</p>
                </Grid>
              ) : null}

              {piutangLoading ? (
                <div className={classes.iconLoadingPiutang}>
                  <CircularProgress />
                </div>
              ) : searchSppt.length > 0 ? (
                <PieChart id="pie" type="doughnut" palette="Soft Pastel" dataSource={searchSppt}>
                  <Series argumentField="tahun" valueField="harus_dibayar">
                    <Label visible={true} customizeText={customizeLabel}>
                      <Connector visible={true} />
                    </Label>
                  </Series>
                  {/*<Export enabled={true} />*/}
                  <Legend visible={false} horizontalAlignment="center" verticalAlignment="bottom" />
                  <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
                </PieChart>
              ) : searchNop.length != 0 ? (
                <div style={{width: '95%'}}>
                  <Alert severity="error">SPPT tidak ditemukan!</Alert>
                </div>
              ) : null}
            </Grid>
          </PerfectScrollbar>
        </div>
      </Fade>

      <div className={classes.detailsHide}>
        <ColorButton
          variant="contained"
          color="default"
          size="small"
          className={classes.detailsHideButton}
          startIcon={<ExpandLessRoundedIcon />}
          onClick={handleDetails}>
          Show Less
        </ColorButton>
      </div>
    </div>
  );
};

export default SearchBrowserDetails;
